import type { IAnimateConfig } from '../interface/graphic';

export const DefaultStateAnimateConfig: IAnimateConfig = {
  duration: 200,
  easing: 'cubicOut'
};
